import React, { useState, useEffect } from 'react';
import { Musterlogobgremove } from '../assets/images';

const scrollTo = (id) => document.querySelector(id)?.scrollIntoView({ behavior: 'smooth' });

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const h = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', h);
    return () => window.removeEventListener('scroll', h);
  }, []);

  const links = ['About','Services','Projects','Process','Contact'];

  return (
    <>
      <div className={`mobile-menu ${open ? 'open' : ''}`}>
        {links.map((l) => (
          <a key={l} href={`#${l.toLowerCase()}`}
            onClick={(e) => { e.preventDefault(); scrollTo(`#${l.toLowerCase()}`); setOpen(false); }}
            style={{ fontFamily:'var(--fh)', fontSize:'2.5rem', fontWeight:800,
              textTransform:'uppercase', color:'var(--wh)', textDecoration:'none', letterSpacing:'0.05em' }}
            onMouseEnter={(e) => (e.target.style.color = 'var(--gold)')}
            onMouseLeave={(e) => (e.target.style.color = 'var(--wh)')}
          >{l}</a>
        ))}
      </div>

      <nav style={{
        position:'fixed', top:0, left:0, right:0, zIndex:100,
        padding:'0 2rem', height:88,
        display:'flex', alignItems:'center', justifyContent:'space-between',
        transition:'background .4s, backdrop-filter .4s',
        background:     scrolled ? 'rgba(30,40,35,0.96)' : '#1E2823',
        backdropFilter: scrolled ? 'blur(14px)' : 'none',
        borderBottom:   scrolled ? '1px solid #1E2823' : 'none',
      }}>
        <a href="#hero" onClick={(e) => { e.preventDefault(); scrollTo('#hero'); }}
          style={{ display:'inline-flex', alignItems:'center', textDecoration:'none', padding:'0.2rem' }}>
          <img
            src={Musterlogobgremove}
            alt="Muster logo"
            style={{ height:190, width:160, objectFit:'fill', display:'block', filter: 'brightness(0) invert(1)' }}
          />
        </a>

        <ul style={{ display:'flex', gap:'2rem', listStyle:'none' }} className="desktop-links">
          {links.map((l) => (
            <li key={l}>
              <a href={`#${l.toLowerCase()}`}
                onClick={(e) => { e.preventDefault(); scrollTo(`#${l.toLowerCase()}`); }}
                style={{ fontSize:'0.82rem', fontWeight:700, letterSpacing:'0.1em',
                  textTransform:'uppercase', color:'#FAFAFA', textDecoration:'none', transition:'color .2s' }}
                onMouseEnter={(e) => (e.target.style.color = 'rgba(250,250,250,0.7)')}
                onMouseLeave={(e) => (e.target.style.color = '#FAFAFA')}
              >{l}</a>
            </li>
          ))}
        </ul>

        <button className="desktop-cta" onClick={() => scrollTo('#contact')} style={{
          background:'#FAFAFA', color:'#1E2823',
          fontFamily:'var(--fh)', fontSize:'0.9rem', fontWeight:700,
          letterSpacing:'0.08em', textTransform:'uppercase',
          padding:'0.5rem 1.25rem', border:'none', cursor:'pointer',
          transition:'background .2s, transform .15s',
        }}
          onMouseEnter={(e) => { e.currentTarget.style.background='rgba(250,250,250,0.85)'; e.currentTarget.style.transform='translateY(-1px)'; }}
          onMouseLeave={(e) => { e.currentTarget.style.background='#FAFAFA';   e.currentTarget.style.transform='none'; }}
        >Get a Quote</button>

        <button onClick={() => setOpen(!open)} className="hamburger" aria-label="Menu" style={{
          display:'none', flexDirection:'column', gap:5,
          background:'transparent', border:'none', cursor:'pointer', padding:4,
        }}>
          {[0,1,2].map((i) => (
            <span key={i} style={{
              display:'block', width:24, height:2, background:'var(--wh)', transition:'0.3s',
              transform: open && i===0 ? 'rotate(45deg) translate(5px,5px)'
                       : open && i===2 ? 'rotate(-45deg) translate(5px,-5px)'
                       : open && i===1 ? 'scaleX(0)' : 'none',
            }} />
          ))}
        </button>
      </nav>

      <style>{`
        @media (max-width: 900px) {
          .desktop-links { display: none !important; }
          .desktop-cta   { display: none !important; }
          .hamburger     { display: flex !important; }
        }
      `}</style>
    </>
  );
}
